import React, { useState, useEffect } from 'react'
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from '../../_metronic/_partials/controls'
import BootstrapTable from 'react-bootstrap-table-next'
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses
} from '../../_metronic/_helpers'
import paginationFactory from 'react-bootstrap-table2-paginator'
import { useSubheader } from '../../_metronic/layout'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import Swal from 'sweetalert2'
import { baseURL, baseURLV1, baseURLDASHBOARD } from '../service/API.js'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import Modal from '@material-ui/core/Modal'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import Pagination from 'react-pagination-library'
import 'react-pagination-library/build/css/index.css'
import { useSelector } from 'react-redux'
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import listProduct from '../../listProduct.json'
import './style.css'

export const User = () => {
  const { user } = useSelector(state => state.auth)
  const suhbeader = useSubheader()
 
  const [users, setUser] = useState([])
  const [approve, setApprove] = useState({ show: false, detail: false })
  const [listItemApprove, setListItemApprove] = useState([{ product_name: "", product_id: "", qty: "", price: "" }])
  const [reject, setReject] = useState(false)
  const [id, setId] = useState('')
  const [detail, setDetail] = useState('')
  const [total, setTotal] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [lastPage, setLastPage] = useState(0)
  const [page, setPage] = useState(1)
  const [openImage, setOpenImage] = useState(false)
  const [imgSelect, setImgSelect] = useState('')
  const [currentPage, setCurrentPage] = useState()
  const [relate, setRelate] = useState()
  const [relate_product_check, setRelateProductCheck] = useState(false)
  const [relate_product_item, setRelateProductItem] = useState()
  const [rotation, setRotation] = useState(0)
  const [bill, setBill] = useState('')
  const [checkBill, setcheckBill] = useState(false)
  const [clickcheckBill, setclickcheckBill] = useState(false)
  const [duplicate_id, setDuplicate_id] = useState('')

  suhbeader.setTitle('User')
  const history = useHistory()

  useEffect(() => {
    // getRelate()
    getUser(1, 10)
  }, [])

  const getRelate = async () => {
    const apiUrls = `${baseURL}/relate-products`
    const resultAll = axios({
      method: 'get',
      url: apiUrls,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${user.data.access_token}`
      }
    })
      .then(async res => {
        setRelate(res.data.data)
        // console.log(res.data.data)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const getUser = async (page, perPage) => {
    let allData = []
    const apiUrls = `${baseURLV1}/userPointTransaction?limit=${perPage}&page=${page}${search !== undefined && search !== '' ? '&search=' + search : ''
      }`
    const resultAll = axios({
      method: 'get',
      url: apiUrls,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${user.data.access_token}`
      }
    })
      .then(async res => {
        await res.data.data.map(async (data, index) => {
          data = {
            id: data.id,
            number: index,
            img: data.medium ? data.medium.file_url : null,
            created_at: data.created_at,
            first_name: data.participant.first_name ? data.participant.first_name : ' ',
            last_name: data.participant.last_name ? data.participant.last_name : ' ',
            mobile: data.participant.phone_number ? data.participant.phone_number : ' ',
            user_type: data.participant.user_type ? data.participant.user_type : ' ',
            status: data.status ? data.status : ' ',
            point: data.point ? data.point : ' ',
            reject_note: data.reject_note ? data.reject_note : ' ',
            bill: data.bill ? data.bill : '-'
          }

          allData.push(data)
        })
        await setTotal(res.data.total)
        await setLastPage(Math.ceil(res.data.total / res.data.limit))
        await setUser(allData)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const getUserID = async (id, bill) => {
    let allData = []
    const apiUrls = `${baseURLV1}/userPointTransaction/user?id=${id}&bill=${bill}`
    const resultAll = axios({
      method: 'get',
      url: apiUrls,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${user.data.access_token}`
      }
    })
      .then(async res => {
        await res.data.data.map(async (data, index) => {
          data = {
            id: data.id,
            number: index,
            img: data.medium ? data.medium.file_url : null,
            created_at: data.created_at,
            first_name: data.participant.first_name ? data.participant.first_name : ' ',
            last_name: data.participant.last_name ? data.participant.last_name : ' ',
            mobile: data.participant.phone_number ? data.participant.phone_number : ' ',
            user_type: data.participant.user_type ? data.participant.user_type : ' ',
            status: data.status ? data.status : ' ',
            point: data.point ? data.point : ' ',
            reject_note: data.reject_note ? data.reject_note : ' ',
            bill: data.bill ? data.bill : '-'
          }

          allData.push(data)
        })
        await setTotal(res.data.total)
        await setLastPage(Math.ceil(res.data.total / res.data.limit))
        await setUser(allData)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const getDetailApprove = async (id) => {
    const apiUrls = `${baseURLV1}/userPointTransaction/bill/${id}`
    const resultAll = axios({
      method: 'get',
      url: apiUrls,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${user.data.access_token}`
      }
    })
      .then(async res => {
        await setListItemApprove(res.data)
        setApprove({ show: true, detail: true })
        setId(id)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const checkDetail = async () => {
    const apiUrls = `${baseURLV1}/userPointTransaction/check/${bill}`
    const resultAll = axios({
      method: 'get',
      url: apiUrls,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${user.data.access_token}`
      }
    })
      .then(async res => {
        if (res.data.result) {
          
          Swal.fire(
            "บิลซ้ำ!",
            `กรุณาตรวจสอบอีกครั้ง (ตรวจสอบ ID ${res.data.duplicate_id}).`,
            "error"
          ).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              handleClose()
              getUserID(res.data.duplicate_id, bill)
            }
          })
        }
        setcheckBill(!res.data.result)
        setclickcheckBill(true)
      })
      .catch(err => {
        setcheckBill(true)
        console.log(err)
      })
  }

  const getUserPage = async p => {
    await getUser(p, perPage)
  }

  const getUserPerPage = async p => {
    await setPerPage(p)
    await getUser(page, p)
  }

  const setOpen = (name, row) => {
    if (name === 'Approve') {
      if (row.point !== ' ') {
        getDetailApprove(row.id)
        setDetail(row)
      } else {
        setApprove({ show: true, detail: false })
        setId(row.id)
        setDetail(row)
      }
    } else {
      setReject(true)
      setId(row.id)
    }
  }

  const setRelateProductOpen = (data, id) => {
    // console.log(data.target.value)
    setRelateProductItem(data.target.value)
    setId(id)
    setRelateProductCheck(true)
  }

  const columns = [
    {
      dataField: 'id',
      text: 'ID',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: 'bill',
      text: 'Bill',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: 'first_name',
      text: 'First name',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: 'last_name',
      text: 'last name',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: 'mobile',
      text: 'Phone number',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: 'user_type',
      text: 'User type',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: 'created_at',
      text: 'Created at',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      text: 'Media',
      dataField: 'img',
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            {row.img !== '' ? (
              <a
                onClick={() => {
                  setOpenImage(true)
                  setImgSelect(row.img)
                }}
              >
                <img
                  style={{
                    width: '100px',
                    height: '100px'
                  }}
                  src={row.img}
                />
              </a>
            ) : (
              ''
            )}
          </div>
        )
      }
    },
    {
      text: 'Status',
      dataField: 'status',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>{row.status == '1' ? 'pending' : (row.status == '2' ? 'approve' : 'reject')}</p>
            <p>{row.reject_note ? row.reject_note : null}</p>
            <p>{row.status === '2' ? row.point + ' point' : null}</p>
          </div>
        )
      }
    },
    {
      text: 'Action',
      dataField: 'number',
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            {row.status == "1" ? (
              <select
                as="select"
                className="dropdown"
                defaultValue={0}
                onChange={name => setOpen(name.target.value, row)}
              >
                <option disabled value={0}>
                  {' '}
                  Action
                </option>
                <option value={'Approve'}>Approve</option>
                <option value={'Reject'}>Reject</option>
              </select>
            ) : (
              row.status == '2' ? (
                <button
                  class="btn btn-primary mr-2"
                  onClick={name => setOpen('Approve', row)}
                >detail</button>
              )
                : null
            )}
          </div>
        )
      }
    }
  ]

  const handleClose = () => {
    setcheckBill(false)
    setclickcheckBill(false)
    setBill('')
    setListItemApprove([{ product_name: "", product_id: "", qty: "", price: "" }])
    setApprove({ show: false, detail: false })
    setReject(false)
    setId('')
    setOpenImage(false)
    setImgSelect('')
    setRelateProductCheck(false)
  }

  const handleSubmitApprove = async () => {
    await setActives()
    return
  }
  const handleSubmitReject = async (values, { setSubmitting }) => {
    await setSubmitting(false)
    await setRejects(values)
    return
  }

  const setActives = async () => {
    const apiUrls = `${baseURLV1}/userPointTransaction/approve`
    axios({
      method: 'post',
      url: apiUrls,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${user.data.access_token}`
      },
      data: {
        user_point_transaction_id: id,
        products: listItemApprove,
        bill: bill
      }
    })
      .then(res => {
        // axios({
        //   method: 'patch',
        //   url: `${baseURL}/transactions/${id}/status`,
        //   headers: {
        //     Accept: 'application/json',
        //     Authorization: `Bearer ${user.data.access_token}`
        //   },
        //   data: {
        //     status: 2,
        //     type: 1
        //   }
        // })
        //   .then(res => {
        getUser(page, perPage)
        handleClose()
        // })
        // .catch(err => {
        //   console.log(err)
        // })
      })
      .catch(err => {
        console.log(err)
      })
  }

  const handleSendEditRelateProduct = () => {
    axios({
      method: 'patch',
      url: `${baseURL}/histories/${id}/relates`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${user.data.access_token}`
      },
      data: {
        type: 1,
        relate_product: relate_product_item
      }
    })
      .then(res => {
        getUser(page, perPage)
        handleClose()
      })
      .catch(err => {
        console.log(err)
      })
  }

  const setRejects = async values => {
    axios({
      method: 'post',
      url: `${baseURLV1}/userPointTransaction/reject`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${user.data.access_token}`
      },
      data: {
        user_point_transaction_id: id,
        reject_note: values.reject_note
      }
    })
      .then(res => {
        getUser(page, perPage)
        handleClose()
      })
      .catch(err => {
        console.log(err)
      })
  }

  const [search, setSearch] = useState()
  const handleSearch = () => {
    getUser(page, perPage)
  }

  const onChanges = e => {
    setPerPage(e.target.value)
    getUserPerPage(e.target.value)
  }

  const pagination = paginationFactory({
    page: lastPage,
    alwaysShowAllBtns: true,
    withFirstAndLast: false,
    pageListRenderer: ({ pages, onPageChange }) => {
      return (
        <div className="dataTables_length" id="datatable-basic_length">
          <label>
            <Pagination
              currentPage={currentPage}
              totalPages={lastPage}
              changeCurrentPage={async numPage => {
                onPageChange(numPage)
                await setPage(numPage)
                await setCurrentPage(numPage)
                await getUserPage(numPage)
              }}
              theme="bottom-border form form-control-sm"
            />
          </label>
        </div>
      )
    },
    sizePerPageRenderer: ({
      options,
      currSizePerPage,
      onSizePerPageChange
    }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={e => {
                onChanges(e)
                onSizePerPageChange(e.target.value)
              }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          }
        </label>
      </div>
    )
  })

  const rotate = () => {
    let newRotation = Number(rotation) + 90
    if (newRotation >= 360) {
      newRotation = -360
    }
    setRotation(newRotation)
  }

  const setItemApprove = async (e, indexItem, field) => {
    if (e) {
      let allData = [];
      await listItemApprove.map((item, index) => {
        if (index == indexItem) {
          if (field == 'product_name') {
            // console.log(e);
            item[field] = e.product_name
            item['product_id'] = e.product_id

          } else {
            // console.log(e.target.value);
            item[field] = e.target.value

          }
          allData.push(item)

        } else {
          allData.push(item)
        }
      });

      setListItemApprove(allData)

      // if (field == 'product_name') {
      //   console.log(1, indexItem, field, e, listItemApprove);
      //   setListItemApprove(statePrev => [statePrev[indexItem] = {...statePrev[indexItem], product_name: e.product_name, product_id: e.product_id} ])

      // } else {
      //   console.log(1, indexItem, field, e.target.value, listItemApprove);
      //   setListItemApprove(statePrev => [statePrev[indexItem] = {...statePrev[indexItem], [field]: e.target.value}])
      // }
    }
  }

  const addItemApprove = () => {
    let itemAdd = { product_name: "", product_id: "", qty: "", price: "" }
    setListItemApprove(statePrev => [...statePrev, itemAdd])
  }
  const deleteItemApprove = async (indexItem) => {
    // console.log(1,listItemApprove);
    let allData = [];
    await listItemApprove.map((item, index) => {
      if (index != indexItem) {
        allData.push(item)
      }
    });

    setListItemApprove(allData)
  }

  console.log(2, approve);
  return (
    <Card>
      <CardHeader title="User"></CardHeader>
      <CardBody>
        <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: '100%' }}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: '100%' }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div>
        <BootstrapTable
          wrapperClasses="table-responsive"
          bordered={false}
          classes="table table-head-custom table-vertical-center overflow-hidden"
          bootstrap4
          keyField="id"
          pagination={pagination}
          data={users === undefined ? [] : users}
          columns={columns}
        >
          <PleaseWaitMessage entities={users} />
          <NoRecordsFoundMessage entities={users} />
        </BootstrapTable>
      </CardBody>

      <Modal
        open={openImage}
        disablePortal
        disableEnforceFocus
        disableAutoFocus
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <TransformWrapper
              defaultScale={1}
              defaultPositionX={200}
              defaultPositionY={100}
            >
              {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                <React.Fragment>
                  <TransformComponent>
                    <div className="modal-body">
                      <img
                        style={{
                          transform: `rotate(${rotation}deg)`,
                          width: '100%',
                          height: '100%',
                          maxWidth: '500px',
                          maxHeight: '500px'
                        }}
                        src={imgSelect}
                      />
                    </div>
                  </TransformComponent>
                  <div className="modal-footer">
                    <div className="tools">
                      <button
                        type="button"
                        className="btn btn-primary mr-1"
                        onClick={rotate}
                      >
                        Rotate
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary mr-1"
                        onClick={zoomIn}
                      >
                        +
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary mr-1"
                        onClick={zoomOut}
                      >
                        -
                      </button>
                    </div>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => handleClose()}
                    >
                      Close
                    </button>
                  </div>
                </React.Fragment>
              )}
            </TransformWrapper>
          </div>
        </div>
      </Modal>

      <Modal className={`modal-approve${approve.detail ? ' see-detail' : ''}`} open={approve.show} disablePortal disableEnforceFocus disableAutoFocus>
        <div className="modal-dialog modal-dialog-centered width-half">
          <div className="modal-content">
            <div className="justify-content-center d-flex align-items-center flex-column mt-1">
              <span style={{ fontSize: '30px' }}>Approve</span>
              <div className='img-preview' style={{ background: `url(${detail.img})` }}>
                {/* <image src={detail.img}/> */}
              </div>
            </div>
            <div className="modal-body">
              <div className="d-block">
                <span className='bill'>หมายเลขบิล</span>

                <div className="list-approve2">
                  <input
                    name={"value"}
                    className={`form-control value ${clickcheckBill && !checkBill ? 'border border-danger' : ''} ${clickcheckBill && checkBill ? 'border border-success' : ''}`}
                    placeholder="bill"
                    value={bill}
                    style={{
                      height: '70px',
                      backgroundColor: '#F4F6F9',
                      borderRadius: '5px',
                      borderWidth: '0'
                    }}
                    onChange={(e) => { setBill(e.target.value) }}
                  />
                  <button className='btn btn-primary' onClick={() => { 
                    checkDetail()
                  }}>ตรวจสอบ</button>

                </div>

                <div className="list-approve">
                  <span className='name'>ชื่อสินค้า</span>
                  <span className='value'>จำนวนชิ้น</span>
                  <span className='value'>ราคาต่อชิ้น</span>
                </div>
                {listItemApprove.length > 0 &&
                  listItemApprove.map((item, index) => {
                    // console.log(item);
                    return <div className="list-approve" key={index}>
                      <Autocomplete
                        id={"name" + index}
                        className="form-control name"
                        options={listProduct}
                        getOptionLabel={(option) => option.product_name}
                        getOptionSelected={(option, value) => option.product_id === value.product_id}
                        onChange={(event, newValue) => {
                          setItemApprove(newValue, index, 'product_name');
                        }}
                        value={item}
                        style={{
                          height: '70px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0'
                        }}
                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                      />
                      <input
                        type="number"
                        name={"value" + index}
                        className="form-control value"
                        placeholder="value"
                        value={item.qty}
                        style={{
                          height: '70px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0'
                        }}
                        onChange={(e) => setItemApprove(e, index, 'qty')}
                      />
                      <input
                        type="number"
                        name={"price" + index}
                        className="form-control value"
                        placeholder="price"
                        value={item.price}
                        style={{
                          height: '70px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0'
                        }}
                        onChange={(e) => setItemApprove(e, index, 'price')}
                      />
                      <button className='btn btn-danger btn-delete' onClick={() => deleteItemApprove(index)}>ลบ</button>
                    </div>
                  })
                }
                <div className="list-approve text-center d-block btn-add">
                  <button className='btn btn-primary' onClick={() => addItemApprove()}>เพิ่มรายการ</button>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-primary"
                onClick={() => handleSubmitApprove()}
                disabled={!(clickcheckBill && checkBill)}
              // disabled={formProps.isSubmitting}
              >
                Approve
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => handleClose()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal open={reject} disablePortal disableEnforceFocus disableAutoFocus>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="justify-content-center d-flex align-items-center mt-1">
              <span style={{ fontSize: '30px' }}>Reject</span>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={{
                  reject_note: ''
                }}
                validate={values => {
                  let errors = {}

                  if (!values.reject_note)
                    errors.reject_note = 'Reject note is required.'

                  return errors
                }}
                onSubmit={handleSubmitReject}
                render={formProps => {
                  return (
                    <Form className="col">
                      <div className="row">
                        <span
                          style={{
                            fontSize: '20px',
                            float: 'left'
                          }}
                        >
                          Reject note :
                        </span>

                        <Field
                          name="reject_note"
                          className="form-control"
                          placeholder="Reject note"
                          style={{
                            height: '38px',
                            width: '530px',
                            backgroundColor: '#F4F6F9',
                            borderRadius: '5px',
                            borderWidth: '0'
                          }}
                        />
                      </div>
                      <div className="form-inline">
                        <ErrorMessage className="colorError" name="reject_note">
                          {msg => <div style={{ color: 'red' }}>{msg}</div>}
                        </ErrorMessage>
                      </div>

                      <div className="modal-footer">
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={formProps.isSubmitting}
                        >
                          Reject
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => handleClose()}
                        >
                          Close
                        </button>
                      </div>
                    </Form>
                  )
                }}
              />
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={relate_product_check}
        disablePortal
        disableEnforceFocus
        disableAutoFocus
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="justify-content-center d-flex align-items-center mt-1">
              <span style={{ fontSize: '30px' }}>Relate product</span>
            </div>
            <div className="modal-body">
              {/* <Form className="col"> */}
              <div className="row">
                <span
                  style={{
                    fontSize: '20px',
                    float: 'left'
                  }}
                >
                  Relate product :{' '}
                </span>

                <input disabled value={relate_product_item} />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  type="submit"
                  onClick={() => handleSendEditRelateProduct()}
                >
                  Ok
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => handleClose()}
                >
                  Close
                </button>
              </div>
              {/* </Form> */}
            </div>
          </div>
        </div>
      </Modal>
    </Card>
  )
}
